<template>
    <div>
        <HeaderPage></HeaderPage>
        <div class="content">
            <SlideShow></SlideShow>
        </div>
        <h2>关于我们</h2>
        <CompanyPage></CompanyPage>
        <h2>产品介绍</h2>
        <ProductcsText></ProductcsText>
        <h2>成功案例</h2>
        <SuccessText></SuccessText>
        <FooterPage></FooterPage>
    </div>
</template>

<script>
import HeaderPage from '@/components/HeaderPage.vue';
import SlideShow from '@/components/SlideShow.vue';
import FooterPage from '@/components/FooterPage.vue';
import ProductcsText from '@/components/ProductcsText.vue';
import SuccessText from '@/components/SuccessText.vue';
import CompanyPage from './CompanyPage.vue';

export default {
    name: "HomePage",
    components: {
        HeaderPage,
        SlideShow,
        CompanyPage,
        ProductcsText,
        SuccessText,
        FooterPage
    }
}

</script>

<style scoped>
.content {
  width: 80%;
  margin: auto;
}
</style>